import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=64a0249c&"
import script from "./ApiTokens.vue?vue&type=script&lang=js&"
export * from "./ApiTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports